<div class="toast-content">
  <mat-icon class="toast-icon" [style.color]="color">
    {{ icon }}
  </mat-icon>

  <span>{{ data.message | translate }}</span>
</div>
